/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { WarrantExerciseService } from '@wealthlane/api-services/wealthlane-captable-service';

const usePostApproveWarrantExercise = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setCheckedValues?: (values: any[]) => void
): UseMutationResult<undefined, unknown, string[], unknown> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (exerciseIds: string[]) => {
      const requestBody = { exerciseIds };
      return await handleRequest(
        WarrantExerciseService.postApiCapTableApiAppWarrantExerciseApproveExercise(requestBody)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message='Exercise(s) approved successfully.' />
          );
          setCheckedValues?.([]);
          await queryClient.invalidateQueries('getWarrantExerciseList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostApproveWarrantExercise;
